<template>
  <insect
    :isActive="actived"
    :parentLimitation="true"
    :minw="1"
    :minh="1"
    :x="bound.left"
    :y="bound.top"
    :w="bound.width"
    :h="bound.height"
    :parentScaleX="scale"
    :parentScaleY="scale"
    :class="{ disabled }"
    :isResizable="resizable"
    :isDraggable="draggable"
    @resizing="resize"
    @dragging="resize"
    @clicked="onClick"
  >
    <el-tooltip
      class="custom-insect"
      effect="dark"
      placement="top"
      :content="name"
    >
      <div class="tooltip-placeholder"></div>
    </el-tooltip>
  </insect>
</template>

<script>
import Insect from 'vue-drag-resize'

export default {
  components: { Insect },
  props: {
    index: Number,
    data: Object,
    actived: Boolean,
    scale: Number,
    disabled: Boolean,
    name: String,
    resizable: {
      type: Boolean,
      default: true
    },
    draggable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      support: ''
    }
  },
  computed: {
    bound() {
      const {
        headPositionX: hx,
        headPositionY: hy,
        tailPositionX: tx,
        tailPositionY: ty
      } = this.data

      return {
        width: Math.round((tx - hx) * this.$parent.width),
        height: Math.round((ty - hy) * this.$parent.height),
        left: Math.round(hx * this.$parent.width),
        top: Math.round(hy * this.$parent.height)
      }
    },
    size() {
      return Math.max(1 / this.scale, 4)
    }
  },
  mounted() {
    this.getSupport()
  },
  beforeDestroy() {
    this.$el.removeEventListener(this.support, this.onScroll)
  },
  methods: {
    getSupport() {
      this.support =
        'onwheel' in document.createElement('div')
          ? 'wheel'
          : document.onmousewheel !== undefined
          ? 'mousewheel'
          : 'DOMMouseScroll'
      this.$el.addEventListener(this.support, this.onScroll)
    },
    onScroll(e) {
      e.preventDefault()
      e.stopPropagation()
    },
    resize(bound) {
      let keys = ['width', 'height', 'left', 'top']
      let isUpdated = !keys.every(k => bound[k] === this.bound[k])
      if (isUpdated) {
        this.$emit('update', this.index, bound)
      }
    },
    onClick(e) {
      e.stopPropagation && e.stopPropagation()
      this.$emit('active', this.index)
    }
  }
}
</script>

<style>
.vdr.inactive {
  /* border: 2px solid rgba(255, 255, 0, 0.9); */
}
.vdr {
  cursor: pointer;
  /* border-color: red !important; */
}
.vdr.active {
  background-color: rgba(0, 255, 255, 0.3);
}
.vdr:hover {
  background-color: rgba(255, 255, 0, 0.3);
}
.vdr.disabled {
  pointer-events: none;
}
.vdr.inactive .content-container {
  /* border: red !important; */
  box-shadow: inset 0 0 0 2px red;
}
.custom-insect {
  /* position: absolute; */
  transform-origin: left top;
  width: 100%;
  height: 100%;
}
.tooltip-placeholder {
  width: 100%;
  height: 100%;
}
</style>
